(function () {
  const defaultMoneyFormat = '${{amount}}';

  /**
   * Format money values based on the shop locale and currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents or 3.00 dollars
   * @param  {String} format - optional custom format string (fallback for unsupported locales)
   * @return {String} value - formatted value
   */
  var formatMoney = function(cents, format) {
      if (typeof cents === 'string') {
          cents = cents.replace('.', '');
      }

      const moneyFormat = window.moneyFormat || "$ {{amount_with_comma_separator}}";
      const amount = Number(cents) / 100;

      try {
          const formattedValue = moneyFormat.replace(/{{\s*[^}]+\s*}}/, amount.toFixed(2));
          const formattedValueWithoutSpaces = formattedValue.replace(/[\u00A0\s]/g, '');

          return formattedValueWithoutSpaces;
      } catch (error) {
          console.warn('Intl.NumberFormat error:', error);
          
          const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
          const formatString = format || defaultMoneyFormat;

          function formatWithDelimiters(
              number,
              precision = 2,
              thousands = ',',
              decimal = '.'
          ) {
              if (isNaN(number) || number == null) {
                  return 0;
              }

              number = number.toFixed(precision);

              const parts = number.split('.');
              const dollarsAmount = parts[0].replace(
                  /(\d)(?=(\d\d\d)+(?!\d))/g,
                  `$1${thousands}`
              );
              const centsAmount = parts[1] ? decimal + parts[1] : '';

              return dollarsAmount + centsAmount;
          }

          let value = '';
          switch (formatString.match(placeholderRegex)[1]) {
              case 'amount':
                  value = formatWithDelimiters(amount, 2);
                  break;
              case 'amount_no_decimals':
                  value = formatWithDelimiters(amount, 0);
                  break;
              case 'amount_with_comma_separator':
                  value = formatWithDelimiters(amount, 2, '.', ',');
                  break;
              case 'amount_no_decimals_with_comma_separator':
                  value = formatWithDelimiters(amount, 0, '.', ',');
                  break;
          }

          return formatString.replace(placeholderRegex, value);
      }
  };

  // Expose formatMoney globally
  window.formatMoney = formatMoney;
})();
